/** Shared read-only demo helpers (zero-friction acquisition). */

/** Post–first-run Ask chips for Customer Payments Hub (verified-ask phrasing). */
export const DEMO_CHIPS = [
  "Context diagram of Customer Payments Hub",
  "Context overview of Customer Payments Hub",
  "What integrates with Customer Payments Hub?",
  "Which technologies does Customer Payments Hub use?",
  "Solution overview of Customer Payments Hub",
];

export function isDemoPath() {
  if (typeof window === "undefined") return false;
  try {
    if (window.location.pathname.replace(/\/+$/, "") === "/demo") return true;
    const p = new URLSearchParams(window.location.search);
    return p.get("demo") === "1";
  } catch {
    return false;
  }
}

export function isDemoSession() {
  try {
    // Only the ephemeral session flag counts. Never treat a real org user as
    // demo because a stale `user.is_demo` lingered in localStorage after login.
    return sessionStorage.getItem("dp_demo") === "1";
  } catch {
    return false;
  }
}

/** Mark demo and drop any prior Ask thread so demo never resumes a trial chat. */
export function markDemoSession(user) {
  try {
    sessionStorage.setItem("dp_demo", "1");
    sessionStorage.removeItem("ea_archimedes_thread_id");
    sessionStorage.removeItem("ea_archimedes_conversation_context");
    const merged = { ...(user || {}), is_demo: true };
    localStorage.setItem("user", JSON.stringify(merged));
    return merged;
  } catch {
    return user;
  }
}

export function clearDemoSession() {
  try {
    sessionStorage.removeItem("dp_demo");
  } catch {
    /* ignore */
  }
  // Strip sticky is_demo from any persisted user so Admin/Editor features
  // are not permanently gated after leaving /demo.
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return;
    const user = JSON.parse(raw);
    if (user && user.is_demo) {
      const { is_demo: _drop, ...rest } = user;
      localStorage.setItem("user", JSON.stringify(rest));
    }
  } catch {
    /* ignore */
  }
}
